import { render } from "./CoinsIcon.vue?vue&type=template&id=18fb6e00"
import script from "./CoinsIcon.vue?vue&type=script&lang=js"
export * from "./CoinsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__